import type { Assistant, AssistantFeature } from './types';

export const FINANCIAL_ASSISTANT_ID = 'cfo';
export const LISTING_FEATURE_ID = 'listing';

export const financialAssistant: Assistant = {
  id: FINANCIAL_ASSISTANT_ID,
  name: '财务总监',
  description: '经营至第 30 周，或已分配航线的飞机 ≥5 架且声誉 ≥55 后解锁。招募后负责上市、审计、股票发行与回购，并每周更新公司估值与股价。',
  featureIds: [LISTING_FEATURE_ID],
  unlocked: (state) => state.week >= 30 || (state.aircraft.filter((a) => a.routeIds.length).length >= 5 && state.reputation >= 55),
  unlockRequirement: '经营至第 30 周，或已分配航线的飞机 ≥5 架且声誉 ≥55',
  recruitCost: 200_000,
  weeklySalary: 10_000,
};

export const listingFeature: AssistantFeature = {
  id: LISTING_FEATURE_ID,
  name: '资本市场',
  description: '允许申请上市、完成审计、进入上市辅导期并发行股票融资。',
  assistantId: FINANCIAL_ASSISTANT_ID,
};
